module.exports = __webpack_public_path__ + "static/musee_olympique_livre3D3-128d2f599b7c487cb6651cf53630f441.png";